import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../../helpers/value'
import { deleteTypes } from '../../constant'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../constant'

const initialState = {
  ids: [],
  byId: {},
  checked: {},
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  typeTemplate: '',
  deleteType: deleteTypes.IN,
  fiinGateTemplateId: '',
}

const slice = createSlice({
  name: 'companyAnalysis/preferenceSetting/templates',
  initialState: initialState,
  reducers: {
    resetStoreTemplates(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeTemplates: (state, action) => {
      const { data, idKey } = action.payload

      state.ids = data.map((template) => {
        if (template.isFiinGateTemplate) {
          state.fiinGateTemplateId = template[idKey]
        }
        return template[idKey]
      })

      state.byId = keyBy(data, idKey)
    },
    checkItem: (state, action) => {
      state.checked[action.payload] = true
    },
    uncheckItem: (state, action) => {
      delete state.checked[action.payload]
    },
    uncheckItems: (state, action) => {
      action.payload.forEach((id) => delete state.checked[id])
    },
    checkAllItem: (state) => {
      state.ids.forEach((id) => {
        if (!state.byId[id].isDefault && !state.byId[id].isFiinGateTemplate) {
          state.checked[id] = true
        }
      })
    },
    uncheckAllItem: (state) => {
      state.checked = {}
    },
    changePage: (state, action) => {
      state.page = action.payload
    },
    changePageSize: (state, action) => {
      state.pageSize = action.payload
    },
    changeTypeTemplate: (state, action) => {
      state.typeTemplate = action.payload
    },
    changeDeleteType: (state, action) => {
      state.deleteType = action.payload
    },
  },
})

export const selectIds = (state) => state[slice.name].ids

export const selectById = (state) => state[slice.name].byId

export const selectCell = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].byId[id], attr)

export const selectChecked = (state) => state[slice.name].checked

export const selectCheckeditem = (id) => (state) =>
  state[slice.name].checked[id]

export const selectPage = (state) => state[slice.name].page

export const selectPageSize = (state) => state[slice.name].pageSize

export const selectTypeTemplate = (state) => state[slice.name].typeTemplate

export const selectDeleteType = (state) => state[slice.name].deleteType

export const selectFiinGateTemplateId = (state) =>
  state[slice.name].fiinGateTemplateId

export const {
  changeTemplates,
  checkItem,
  uncheckItem,
  uncheckItems,
  checkAllItem,
  uncheckAllItem,
  changePage,
  changePageSize,
  resetStoreTemplates,
  changeTypeTemplate,
  changeDeleteType,
} = slice.actions

register(slice.name, slice.reducer)
